<!-- not sure this is required and shows up during tab transitions -->
<!--<p *ngIf="!valid.getValid()" style="padding: 10px 10px 0 10px;">There are no actions available at the current location.</p>-->

@if (validFieldData) {
  <section (click)="closeOptions()">
    @if (breadcrumbs && breadcrumbs.pathItems.length > 0) {
      <app-breadcrumbs
        [path]="breadcrumbs!"
        (pathItemSelectedEvent)="breadcrumbSelected($event)"
        >
      </app-breadcrumbs>
    }
    @if (isLeafWithOptions) {
      <p>There are no configurable options available for this field.</p>
    }
    @if (isLeafWithoutOptions) {
      <p>Configurable options available for this field. Navigate elsewhere in the document to add more fields.</p>
    }
    @if (!optionsOpen && fieldIsConfigurable) {
      <button
        @buttonInOut
        (click)="openConfig($event)"
        class="insert-update-field"
        theme="medium"
        title="Configuration options for {{ validFieldData.activeField?.label }}"
        >
        {{ validFieldData.activeField?.label }} OPTIONS
      </button>
    }
    <!-- TODO: Placeholder if at top level, e.g. "Search Assignments fields..." -->
    @if (!isLeaf) {
      <mat-tab-group
        class="data-fields"
        [disablePagination]="true"
        [(selectedIndex)]="selectedTabIndex"
        animationDuration="200ms"
        >
        <mat-tab [disabled]="repeatableItems.length === 0" title="Associated fields">
          <ng-template mat-tab-label>
            <mat-icon title="Associated fields">low_priority</mat-icon>
            <span>Associated fields</span>
          </ng-template>
          <app-filterable-list
            id="repeatable-fields"
            #repeatable
            [title]="'Associated fields'"
        [placeholder]="
          validFieldData.activeField?.label ? 'Search ' + validFieldData.activeField?.label + ' fields...' : 'Search fields...'
        "
            [items]="repeatableItems"
            (itemInsertedEvent)="onFieldInserted($event, repeatable)"
            >
          </app-filterable-list>
        </mat-tab>
        <mat-tab [disabled]="fieldItems.length === 0">
          <ng-template mat-tab-label>
            <mat-icon title="Fields">text_fields</mat-icon>
            <span>Fields</span>
          </ng-template>
          <app-filterable-list
            #fields
            [title]="'Fields'"
        [placeholder]="
          validFieldData.activeField?.label ? 'Search ' + validFieldData.activeField?.label + ' fields...' : 'Search fields...'
        "
            [items]="fieldItems"
            (itemInsertedEvent)="onFieldInserted($event, fields)"
            >
          </app-filterable-list>
        </mat-tab>
      </mat-tab-group>
    }
  </section>
}

<!-- CONFIG OPTIONS -->
<aside [ngClass]="optionsOpen ? 'options-open' : ''">
  <app-field-config
    #fieldConfigComponent
    [field]="validFieldData?.activeField"
    [fields]="focusedFieldActionFields"
    [(config)]="fieldConfig"
    (closeEvent)="closeOptions()"
    >
  </app-field-config>
  @if (optionsOpen) {
    <button
      (click)="onUpdateClick()"
      [ngClass]="{ 'needs-saving': modified }"
      [disabled]="!modified"
      theme="medium"
      class="insert-update-field"
      title="Update current field in Document"
      >
      <mat-icon fontIcon="arrow_back_ios_new"></mat-icon>
      UPDATE FIELD
    </button>
  }
</aside>
